<template>
  <div class="TripDisplayEdit">
    <ActionButton
      variant="tertiary"
      leftIcon="pencil"
      :size="buttonSize"
      :disabled
      @click="$emit('edit')"
    >
      {{ t('ui.booking.availability.results.edit') }}
    </ActionButton>
  </div>
</template>

<script setup lang="ts">
import { useResponsive } from '@cvo/ui/composables';
import { computed } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';
import ActionButton from '../../../atoms/ActionButton/ActionButton.vue';

defineProps<{
  disabled: boolean;
}>();

defineEmits<{
  edit: [];
}>();

const { t } = useI18n();
const { isMobile } = useResponsive();

const buttonSize = computed(() => {
  return isMobile.value ? 'sm' : 'md';
});
</script>

<style lang="scss">
@layer cvo-ui {
  .TripDisplayEdit {
    display: grid;
    place-content: center;
  }
}
</style>